import { RootState } from "./types";
import { ActionContext } from "vuex";

export default {
    reload({ commit }: ActionContext<RootState, any>) {
        commit("reload");
    }
};
